import React, { FC, ReactNode } from 'react';

import { Helmet } from 'react-helmet';
import { FormattedMessage } from 'react-intl';

interface IPageTitleWrapper {
  pageTitle: string;
  children: ReactNode;
}

const PageTittleWrapper: FC<IPageTitleWrapper> = ({ pageTitle, children }) => (
  <>
    <FormattedMessage id={pageTitle}>
      {title => {
        const finalTitle = `${title} — Skiloope`;
        return (
          <Helmet>
            <title>{finalTitle}</title>
          </Helmet>
        );
      }}
    </FormattedMessage>
    {children}
  </>
);

export { PageTittleWrapper };
